import React, { useState, useEffect} from "react";
import PropTypes from "prop-types";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const MobileInput = ({
  name,
  title,
  value,
  error,
  handleChange,
  placeholder,
  page,
}) => {
  const [newValue, setNewvalue] = useState();
  const handleMobile = (e, data) => {
  
    const digitsOnly = e.replace(/\D/g, "").slice(-15); // ✅ Keep last 10 digits only
    if (digitsOnly.length <= 15) {
      handleChange({
        name: name,
        value: digitsOnly,
        country_code: data.countryCode,
      });
    }
  };

 

 
  return (
    <div className={` text-start`}>
      {title && (
        <label className="d-flex align-items-center fs-12 min-200 mb-1 form-label">
          <span className="required">{title}</span>
        </label>
      )}

      <PhoneInput
        country={"in"}
        // onlyCountries={['in']}
        // disableDropdown
        value={value}   // a
        // value={value ? `+91${value}` : "+91"}
        // disableCountryCode
        countryCodeEditable={false}
       
        placeholder={placeholder}
        enableLongNumbers={false}
        onChange={(e, data) => {
         
          const digitsOnly = e.replace(/\D/g, "");
          if (digitsOnly.length <= 15) {
            handleMobile(e, data);
          }
        }}
        inputProps={{
          name: name,
          required: true,
          autoFocus: false,
          maxLength: 15,
        }}
        inputclassName="w-100 no-country-code"
      />
      
        <div style={page ? { height: "20px" } : {}} className="mb-2">
          <span className="fs-10 text-danger">{error}</span>
        </div>
    </div>
  );
};

MobileInput.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.any,
  error: PropTypes.string,
  handleChange: PropTypes.func,
  placeholder: PropTypes.string,
  page: PropTypes.string,
};

export default MobileInput;
